<template>
<section class="section searchResults speciesTable">
  <div class="container">
    <div class="bodySearchResults">
      <div class="resultHeader">

          <div class="photo is-hidden-mobile">
          </div>
          <div class="common name">
            <p class="caps"><strong>{{ $t("habitat.title") }}</strong></p>
          </div>
          <div class="categories is-hidden-mobile">
          </div>
      </div>
      <div class="resultList">
        <template v-for="(item, $index) in list" :key="'main-row' + $index">
          <div class="singleResult" >
            <div class="photo is-hidden-mobile">
              <img :src="profileImageUrlPrefix + item.elements[0]?.label" alt="placeholder" class="rounded-1">
            </div>
            <!-- <div class="summaryImg">
              <img src="img/sampleThumb.jpg" alt="placeholder">
            </div> -->
            <div class="common name">
              {{ item.label }}
            </div>
            <div class="categories" @click="item.show = !item.show">
              <span class="icon is-small">
                <svg class="arrowDown">
                  <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
                </svg>
              </span>
            </div>
          </div>
          <div class="singleResult subRow" v-show="item.show">
            <div class="photo is-hidden-mobile"></div>
            <div class="richtext name" v-html="item.description">
            </div>
            <div class="categories">
              <div v-for="(subItem, index2) in item.elements" :key="'sub-row' + index2">
                <a :href="getProfileUrl({commonName: subItem?.label}, taxonomic.habitat)">
                  <span>{{subItem.label}}</span>
                </a>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getHabitatTable } from '@/services/data/biobrowser-data.js';
import { getProfileUrl, taxonomic } from '@/config/profile-config.js';

export default {
  name: 'habitat-table',
  setup (props) {
    const profileImageUrlPrefix = import.meta.env.VITE_APP_PHOTO_PROFILE_URL_PREFIX;

    const list = ref([]);

    onMounted(async () => {
      const data = await getHabitatTable();
      list.value.push(...data);
      list.value.forEach(x => { x.show = false; });
    });

    const openProfile = (item) => {
      const url = getProfileUrl(item, taxonomic.habitat);
      window.location.href = url;
    };
    return {
      profileImageUrlPrefix,
      openProfile,
      getProfileUrl,
      list,
      taxonomic
    }
  }
}
</script>

<style scoped>
  .resultHeader {
    padding: 10px;
  }
  .singleResult .categories div{
    padding: 20px 0;
  }
  .singleResult span:hover {
    cursor: pointer;
    color: #ac7fb0;
    font-weight: 700;
  }
  .bodySearchResults .resultHeader .categories, .bodySearchResults .singleResult .categories {
    text-align: right;
    padding: 0 14px;
    width: 45%;
    height: 100%;
}
</style>
